<template>
  <i
    class="bi"
    :class="{ 'bi-chevron-down': isOpen, 'bi-chevron-right': !isOpen }"
  />
</template>

<script>
export default {
  name: 'AccordionCaret',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
